import script from "./InformationShow.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationShow.vue?vue&type=script&setup=true&lang=js"

import "./InformationShow.vue?vue&type=style&index=0&id=7691845a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7691845a"]])

export default __exports__